// Verify Email Page
import { useSearchParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  
  useEffect(() => {
    const verify = async () => {
      try {
        const res = await fetch('/api/auth/verify-email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: params.get('token') })
        });
        const data = await res.json();
        setStatus(data.success ? 'success' : 'error');
      } catch { setStatus('error'); }
    };
    verify();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card bg-base-100 shadow-xl max-w-md w-full p-8 text-center">
        {status === 'loading' && <span className="loading loading-spinner loading-lg text-primary"></span>}
        {status === 'success' && <><h2 className="text-2xl font-bold text-success mb-4">Email Verified!</h2><p className="text-gray-600 mb-6">Your email has been successfully verified. You can now login.</p><Link to="/auth/login" className="btn btn-primary text-white">Go to Login</Link></>}
        {status === 'error' && <><h2 className="text-2xl font-bold text-error mb-4">Verification Failed</h2><p className="text-gray-600 mb-6">The link may be expired or invalid. Please try again.</p><Link to="/auth/login" className="btn btn-primary text-white">Go to Login</Link></>}
      </div>
    </div>
  );
}